import { produce } from 'immer';

import { FINANCIAL_INFO_ACTION_TYPE } from '../actions';

const initialState = {
  isClosedHidden: true,
};

const financialInfoReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case FINANCIAL_INFO_ACTION_TYPE.GET_SUMMARY:
        draft.summary = payload;
        break;

      case FINANCIAL_INFO_ACTION_TYPE.GET_ASSETS:
        draft.assets = payload;
        break;

      case FINANCIAL_INFO_ACTION_TYPE.GET_LIABILITIES:
        draft.liabilities = payload;
        break;

      case FINANCIAL_INFO_ACTION_TYPE.GET_INCOMES:
        draft.incomes = payload;
        break;

      case FINANCIAL_INFO_ACTION_TYPE.GET_PROPERTIES:
        draft.properties = payload;
        break;

      case FINANCIAL_INFO_ACTION_TYPE.TOGGLE_IS_CLOSED_HIDDEN:
        draft.isClosedHidden = !draft.isClosedHidden;
        break;

      default:
        return state;
    }
  });

export default financialInfoReducer;
